import { paths as navBarMenuPaths } from 'components/Navbar/NavbarMenu/paths'

export const paths = {
  ...navBarMenuPaths,
}
